module.exports = __webpack_public_path__ + "static/media/41d5efb8acd3487afc5ddea1501f0b08.41d5efb8.webp";